import React from 'react';
import "./HomeClientNew.scss"

export default function NextPayments({ main, isMobile }) {
  return (
    <div className="card-section next-payments-box" style={isMobile ? { borderBottom: "2px solid #EFEFEF" } : {}}>
      <h5 className="mb-4">Next Payments You Arrange</h5>
      <div className="card-section mt-2" style={{ height: '100px' }}>
        <div className="border-new w-100">
          <div>
            <h5>{main?.user?.first_name} {main?.user?.last_name}</h5>
          </div>
          <div>
            <span className="account-number"> Current Account: {main?.user?.detail?.account_number?.replace(/^.*?-/, '')}</span>
          </div>
        </div>
      </div>

      <p className="text-muted small">
        THERE ARE CURRENTLY NO PAYMENT INSTRUCTIONS EXPIRING
      </p>
    </div >
  );
}
